import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { FC, memo } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useFollow } from '@hooks/TRPC_Hooks/useFollow';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { useTranslation } from '@hooks/useTranslation';
import { LinksEnum } from '@specs/navigation';
import { SocialManagerView } from '@specs/views';
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  size: 'medium',
  color: 'Black'
};
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
}
const MemoizedFollowButton: FC<Props> = ({
  shortid
}) => {
  const {
    updatePostsData
  } = useInvalidate();
  const {
    status
  } = useSession();
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const {
    mutateAsync: followMutate
  } = useFollow();
  const followHandler = async () => {
    if (status === 'unauthenticated') {
      return await router.push(LinksEnum.SIGN_IN);
    }
    await followMutate({
      shortid
    });
    updatePostsData();
  };
  return <Button id='follow_button' {...defaultButtonProps} onClick={followHandler} data-sentry-element="Button" data-sentry-component="MemoizedFollowButton" data-sentry-source-file="FollowButton.tsx">
			{tr({
      id: 'btn.follow'
    })}
		</Button>;
};
export const FollowButton = memo(MemoizedFollowButton);